import ClearIcon from './clear-icon';

export default ClearIcon;
